import React from "react";
import { connect } from "react-redux";
import { BookingDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import {
  AudioEquipmentContainer,
  BosendorferContainer,
  MusicalInstrumentContainer,
} from "./Types";
import { Navigations } from "components";

class BookingDetailContainer extends React.Component {
  render() {
    const { router, t } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Flagship store Bangkok", { ns: "common" }),
        path: ROUTE_PATH.BOOKING,
      },
    ];
    return (
      <BookingDetailContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="booking_detail_container">
          {router.params?.category_id === "1" && <MusicalInstrumentContainer />}
          {router.params?.category_id === "2" && <AudioEquipmentContainer />}
          {router.params?.category_id === "3" && <BosendorferContainer />}
        </div>
      </BookingDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(BookingDetailContainer)));
